import { t } from 'ttag'

export const VIEW_MODE_BASIC = 'explorer'
export const VIEW_MODE_MANAGEMENT = 'navigator'
export const LESSON_UPDATED_EVENT = 'lesson-updated-event'
export const US_STATES_LIST = [
  {
    value: 'AL',
    label: t`Alabama`
  },
  {
    value: 'AK',
    label: t`Alaska`
  },
  {
    value: 'AZ',
    label: t`Arizona`
  },
  {
    value: 'AR',
    label: t`Arkansas`
  },
  {
    value: 'CA',
    label: t`California`
  },
  {
    value: 'CO',
    label: t`Colorado`
  },
  {
    value: 'CT',
    label: t`Connecticut`
  },
  {
    value: 'DE',
    label: t`Delaware`
  },
  {
    value: 'DC',
    label: t`Washington D.C.`
  },
  {
    value: 'FL',
    label: t`Florida`
  },
  {
    value: 'GA',
    label: t`Georgia`
  },
  {
    value: 'HI',
    label: t`Hawaii`
  },
  {
    value: 'ID',
    label: t`Idaho`
  },
  {
    value: 'IL',
    label: t`Illinois`
  },
  {
    value: 'IN',
    label: t`Indiana`
  },
  {
    value: 'IA',
    label: t`Iowa`
  },
  {
    value: 'KS',
    label: t`Kansas`
  },
  {
    value: 'KY',
    label: t`Kentucky`
  },
  {
    value: 'LA',
    label: t`Louisiana`
  },
  {
    value: 'ME',
    label: t`Maine`
  },
  {
    value: 'MD',
    label: t`Maryland`
  },
  {
    value: 'MA',
    label: t`Massachusetts`
  },
  {
    value: 'MI',
    label: t`Michigan`
  },
  {
    value: 'MN',
    label: t`Minnesota`
  },
  {
    value: 'MS',
    label: t`Mississippi`
  },
  {
    value: 'MO',
    label: t`Missouri`
  },
  {
    value: 'MT',
    label: t`Montana`
  },
  {
    value: 'NE',
    label: t`Nebraska`
  },
  {
    value: 'NV',
    label: t`Nevada`
  },
  {
    value: 'NH',
    label: t`New Hampshire`
  },
  {
    value: 'NJ',
    label: t`New Jersey`
  },
  {
    value: 'NM',
    label: t`New Mexico`
  },
  {
    value: 'NY',
    label: t`New York`
  },
  {
    value: 'NC',
    label: t`North Carolina`
  },
  {
    value: 'ND',
    label: t`North Dakota`
  },
  {
    value: 'OH',
    label: t`Ohio`
  },
  {
    value: 'OK',
    label: t`Oklahoma`
  },
  {
    value: 'OR',
    label: t`Oregon`
  },
  {
    value: 'PA',
    label: t`Pennsylvania`
  },
  {
    value: 'PR',
    label: t`Puerto Rico`
  },
  {
    value: 'RI',
    label: t`Rhode Island`
  },
  {
    value: 'SC',
    label: t`South Carolina`
  },
  {
    value: 'SD',
    label: t`South Dakota`
  },
  {
    value: 'TN',
    label: t`Tennessee`
  },
  {
    value: 'TX',
    label: t`Texas`
  },
  {
    value: 'UT',
    label: t`Utah`
  },
  {
    value: 'VT',
    label: t`Vermont`
  },
  {
    value: 'VA',
    label: t`Virginia`
  },
  {
    value: 'VI',
    label: t`Virgin Islands`
  },
  {
    value: 'WA',
    label: t`Washington`
  },
  {
    value: 'WV',
    label: t`West Virginia`
  },
  {
    value: 'WI',
    label: t`Wisconsin`
  },
  {
    value: 'WY',
    label: t`Wyoming`
  }
]
export const PUBLIC_EMAIL_DOMAINS_LIST = [
  'aol.com',
  'att.net',
  'comcast.net',
  'facebook.com',
  'gmail.com',
  'gmx.com',
  'googlemail.com',
  'google.com',
  'hotmail.com',
  'hotmail.co.uk',
  'mac.com',
  'me.com',
  'mail.com',
  'msn.com',
  'live.com',
  'sbcglobal.net',
  'verizon.net',
  'yahoo.com',
  'yahoo.co.uk',
  'bellsouth.net',
  'charter.net',
  'cox.net',
  'earthlink.net',
  'juno.com',
  'email.com',
  'fastmail.fm',
  'games.com',
  'gmx.net',
  'hush.com',
  'hushmail.com',
  'icloud.com',
  'iname.com',
  'inbox.com',
  'lavabit.com',
  'love.com',
  'outlook.com',
  'pobox.com',
  'protonmail.ch',
  'protonmail.com',
  'tutanota.de',
  'tutanota.com',
  'tutamail.com',
  'tuta.io',
  'keemail.me',
  'rocketmail.com',
  'safe-mail.net',
  'wow.com',
  'ygm.com',
  'yahoo.com.mx',
  'live.com.mx',
  'hotmail.es',
  'hotmail.com.mx',
  'prodigy.net.mx',
  'ymail.com',
  'zoho.com',
  'yandex.com',
  'yahoo.ca',
  'hotmail.ca',
  'bell.net',
  'shaw.ca',
  'sympatico.ca',
  'rogers.com'
]
